import React, {useEffect, useState} from 'react';

import { CustomSpinner } from '_atoms';

const LoadingContainer = (props) => {

    return (
        <>
        <div style={{
            opacity: props.loading ? 0.4 : 1.0
        }}>
            {props.children}
        </div>

        <div style={{ marginTop: props.marginTop }}>
            {props.loading && <CustomSpinner rowCenter={true} /> }
        </div>
        </>
    );
};

export default LoadingContainer;
